import React, { useState } from 'react'
import Head from 'next/head'

import { Menu, Container } from '../../components'
import styles from '~/styles/layout.module.css'

const Layout = ({ 
    action, children, links, locale, t, title, showPickup,
    onClickLabel, callback, removeChartDateAndStatus,
    setCurrentPage,
    timezoneCode, setTimezoneCode,
    timezoneName, setTimezoneName,
    sortingPickerType, setSortingPickerType,
    appState, setAppState,
    onAction, route, currentDealer
  }) => {
  const [ clickLabel, setClickLabel ] = useState(null)
  const onClick = (event) => {
    const target = event.target
    let clickLabelValue = null
    const closestClickLabelElement = target.closest('[clicklabel]')
    if (closestClickLabelElement) {
      clickLabelValue = closestClickLabelElement.getAttribute('clicklabel')
    }
    setClickLabel(clickLabelValue)
    if (typeof onClickLabel === 'function') {
      onClickLabel(clickLabelValue)
    }
  }
  return (
      <div
        className={styles.main}
        onClick={onClick}
      >
        <Head>
          <title>{t(`common:${title}`)} - Via.Delivery</title>
        </Head>
        <Menu
          t={t}
          locale={locale}
          action={action}
          links={links}
          showPickup={showPickup}
          clickLabel={clickLabel}
          title={title}
          callback={callback}
          removeChartDateAndStatus={removeChartDateAndStatus}
          setCurrentPage={setCurrentPage}
          timezoneCode={timezoneCode}
          setTimezoneCode={setTimezoneCode}
          timezoneName={timezoneName}
          setTimezoneName={setTimezoneName}
          sortingPickerType={sortingPickerType}
          setSortingPickerType={setSortingPickerType}
          appState={appState}
          setAppState={setAppState}
          onAction={onAction}
          route={route}
        />
        <Container>
          {children}
        </Container>
      </div>
  )
}

export default Layout